module.exports = __webpack_public_path__ + "static/img/pbg.fee8a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/pbg.jpg
// module id = bVuz
// module chunks = 0